var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_466_19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.32715 6.90378C2.32715 7.49363 2.44333 8.07771 2.66906 8.62266C2.89478 9.16762 3.22564 9.66277 3.64273 10.0799C4.05982 10.497 4.55497 10.8278 5.09993 11.0535C5.64488 11.2793 6.22896 11.3954 6.81882 11.3954C7.40867 11.3954 7.99275 11.2793 8.5377 11.0535C9.08266 10.8278 9.57781 10.497 9.9949 10.0799C10.412 9.66277 10.7428 9.16762 10.9686 8.62266C11.1943 8.07771 11.3105 7.49363 11.3105 6.90378C11.3105 6.31392 11.1943 5.72984 10.9686 5.18489C10.7428 4.63994 10.412 4.14478 9.9949 3.72769C9.57781 3.3106 9.08266 2.97974 8.5377 2.75402C7.99275 2.52829 7.40867 2.41211 6.81882 2.41211C6.22896 2.41211 5.64488 2.52829 5.09993 2.75402C4.55497 2.97974 4.05982 3.3106 3.64273 3.72769C3.22564 4.14478 2.89478 4.63994 2.66906 5.18489C2.44333 5.72984 2.32715 6.31392 2.32715 6.90378Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8773 13.9613L10.0273 10.1113",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_466_19"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.4,
    height: 15.4,
    fill: "white",
    transform: "translate(0.402344 0.486328)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchicon);
export default __webpack_public_path__ + "static/media/searchicon.03cef5e64c0e6248ca1073b41a7b58bb.svg";
export { ForwardRef as ReactComponent };